export default __webpack_public_path__ + "images/blue_arrow_left-23d57c3a59e50f344cf6e6a4e2044cad.svg";